import { combineReducers } from "redux"
import { routerReducer } from "react-router-redux"
import home from './home'
import SignUp from './SignUp'
import SignIn from './SignIn'
import Profile from './Profile'
import ContactUs from './ContactUs'
import Category from './Admin/Category'
import AdminUsersList from './Admin/Users'
import ContactUsAdmin from './Admin/ContactUs'
import AdminHome from './Admin/Home'
import CountryStaeCity from './Admin/CountryStaeCity'
import AdminBlog from './Admin/Blog'
import FindRecCompany from './FindRecCompany'
import SendResume from './SendResume'
import Speclization from './Speclization'
import Notification from './Notification'
import SubUser from './Subuser'
import Chat from './Chat'
import Job from './Job'
const reducer = combineReducers({
   router:
   routerReducer,   
   home, 
   SignUp,
   SignIn,  
   ContactUs,
   AdminHome,
   AdminUsersList,
   Category,  
   Profile,
   ContactUsAdmin,
   FindRecCompany,
   SendResume,   
   Speclization,
   CountryStaeCity,
   Notification,
   Chat,
   SubUser,
   AdminBlog,
   Job   
})
export default reducer 



// WEBPACK FOOTER //
// ./src/reducers/index.js